import type { IconData } from '@stacksjs/iconify-core'

export const starHalf: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M135.539 453.9a7.979 7.979 0 0 1-11.51-8.362L144.6 312.2l-95.02-95.789a8 8 0 0 1 4.4-13.53l133.17-21.643L256 76.2V17.833l-18.763 28.624l-69.126 105.455L48.843 171.3a39.85 39.85 0 0 0-31.626 27.122A41 41 0 0 0 16 203.183v15.276a39.9 39.9 0 0 0 10.862 20.488l83.65 84.327L92.4 440.663a39.979 39.979 0 0 0 57.548 41.812L256 428.977v-35.841Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default starHalf
